import { configureStore } from '@reduxjs/toolkit';
import branchSlice from './slices/branchSlice';
import mappingSlice from './slices/mappingSlice';
import orderSlice from './slices/orderSlice';
import reportsSlice from './slices/reportsSlice';
import uiSlice from './slices/uiSlice';
import authSlice from './slices/authSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    branches: branchSlice,
    mappings: mappingSlice,
    orders: orderSlice,
    reports: reportsSlice,
    ui: uiSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;